module.exports = __webpack_public_path__ + "images/emoji/six_pointed_star.cfc142e04d2d5d7c28fc.png";